/* eslint-disable */
import '../polyfills';
import { EmagineBlocks } from './core';
import { EmPanels } from './panels';

window.addEventListener('DOMContentLoaded', EmagineBlocks.dispatchEvents);

window.addEventListener('EmagineBlocks:setup', (e) => {
	EmagineBlocks.addComponent('panels', EmPanels, {});
	window.EmagineBlocks = EmagineBlocks;
});

window.addEventListener('EmagineBlocks:init', (e) => {
	window.EmagineBlocks.init();
});
/* eslint-enable */
